import Image from 'app/Components/Shared/Image/image';
import React, { useState } from 'react';
import Config from 'app/Config';
const ImportantToKnowItem = (props) => {
    return (
        <div className='important-list-item' key={props.index}>
            <div className='important-list-item-icon'>{props.item.itemIcon?.value && <Image src={Config.epiBaseUrl + props.item.itemIcon?.value} />}</div>
            <div className='important-list-item-text'><span dangerouslySetInnerHTML={{ __html: props.item.itemText?.value }} /> </div>
        </div>
    );
};

export default ImportantToKnowItem;
